import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么选择红桃影院看综艺
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 text-center group hover:bg-background-200/50 transition-colors cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}